import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

import {req} from '~/utils/request'

const initialState = {}

export const getSharePageInfo = createAsyncThunk<any, any>(
  'getSharePageInfo',
  async (arg) => {
    return req({
      url: '/api/share/get_share_page',
      params: {...arg},
    })
  }
)

export const getShareMangaSnippet = createAsyncThunk<any, any>(
  'getShareMangaSnippet',
  async (arg) => {
    return req({
      url: '/api/share/manga_snippet',
      params: {...arg},
    })
  }
)

export const getInviteLanding = createAsyncThunk<any, any>(
  'getInviteLanding',
  async (arg) => {
    return req({
      url: '/api/quota/invite_landing',
      params: {...arg},
    })
  }
)

export const shareSlice = createSlice({
  name: 'share',
  initialState,
  reducers: {},
  extraReducers: () => {},
})

export default shareSlice.reducer
